<template>
  <div class="item">
    <Tips
      :is-show="isShowTips"
      :state="item.used"
    />
    <a
      target="_blank"
      :href="item.url"
      @mouseenter="isShowTips=true"
      @mouseleave="isShowTips=false"
    >
      {{ item.name }}
    </a>
  </div>
</template>

<script>
import Tips from '@/components/Navigation/Tips.vue';

export default {
  components: { Tips },
  props: {
    item: {
      type: Object,
      default: () => ({
        name: 'null',
        url: '',
        state: 'normal',
      }),
    },
  },
  data() {
    return {
      isShowTips: false,
    };
  },
  methods: {
    onShowTips(status) {
      this.isShowTips = true;
      const DISABLE = 'disable';
      const NORMAL = 'normal';
      const DOWNLOAD = 'download';
      const SSO = 'sso';
      if (status === DISABLE) {
        return 'disable';
      }
      if (status === NORMAL) {
        return 'normal';
      }
      if (status === DOWNLOAD) {
        return 'download';
      }
      if (status === SSO) {
        return 'sso';
      }
      return 'null';
    },
  },
};
</script>

<style lang="scss" scoped>
.item{
  position: relative;
  a {
    cursor: pointer;
    color: #1e3ca8;
  }
  a:hover{
    color: #788acb;
  }
}
</style>
